export class PickerRegistry {
    constructor() {
        this.entries = new Map;
    }
    register(key, picker) {
        this.entries.set(key, picker);
    }
    unregister(key) {
        this.entries.delete(key);
    }
    get(key) {
        return this.entries.get(key);
    }
    getAll() {
        return Array.from(this.entries.values());
    }
    clear() {
        this.entries.clear();
    }
}
//# sourceMappingURL=picker-registry.js.map
